import { render } from "./SearchNews.vue?vue&type=template&id=26718264&scoped=true"
import script from "./SearchNews.vue?vue&type=script&lang=js"
export * from "./SearchNews.vue?vue&type=script&lang=js"

import "./SearchNews.vue?vue&type=style&index=0&id=26718264&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26718264"]])

export default __exports__